import { TextFootnote, token } from '@ferreri/prever-component-lib';
import styled from '@emotion/styled';
import { ExtendedGroupType } from './rules.types';
import { getCurrentKinshipInFirstPosition } from '../plan-detail.store';
import { SiblingLabel } from './SiblingLabel';

type SiblingGroupLabelsProps = {
  siblingGroups: ExtendedGroupType[];
  mainKinshipName: string;
};

export const SiblingGroupLabels = (props: SiblingGroupLabelsProps) => {
  const financialDependentExists = props.siblingGroups?.some(
    (dep) => dep.is_financial_dependent,
  );

  const kinships = getCurrentKinshipInFirstPosition(
    props.siblingGroups,
    props.mainKinshipName,
  );

  return (
    <KinshipContent>
      <KinshipListContainer>
        {kinships?.map((sibling, index) => {
          return <SiblingLabel key={index} sibling={sibling} index={index} />;
        })}
      </KinshipListContainer>
      {financialDependentExists && (
        <TextFootnote>* Dependente financeiro</TextFootnote>
      )}
    </KinshipContent>
  );
};

const KinshipContent = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
  gap: ${token.spacing.spacingXxSmall};
`;

const KinshipListContainer = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
  gap: ${token.spacing.spacingXxxSmall};
`;
